import { useMemo } from 'react';
import { useCompanySorting, useCompanyHeading } from 'state/companySorting';

export const COMPANY_TABLE_HEADINGS = {
  COMPANY_NAME: 'company_name',
  ACTIVE_PROJECTS: 'active_projects',
  TYPE: 'type',
};

export const useSortedCompanies = () => {
  const { companySorting: isSorted, setCompanySorting: setSorted } = useCompanySorting();
  const { companyHeading: heading, setCompanyHeading: setCurrentHeading } =
    useCompanyHeading();

  const sortArray = useMemo(() => {
    if (!heading) return [];

    const reverse = isSorted;
    let sortField = '';

    switch (heading) {
      case COMPANY_TABLE_HEADINGS.COMPANY_NAME:
        sortField = 'name';
        break;
      case COMPANY_TABLE_HEADINGS.ACTIVE_PROJECTS:
        sortField = 'num_active_projects';
        break;
      case COMPANY_TABLE_HEADINGS.TYPE:
        sortField = 'company_types';
        break;
      default:
        return [];
    }

    const sortValue = reverse ? `-${sortField}` : sortField;

    return [sortValue];
  }, [heading, isSorted]);

  const sortByHeading = (sortHeading: string) => {
    if (heading === sortHeading) {
      // Toggle sort direction if clicking the same column
      setSorted((prev) => !prev);
    } else {
      // Set new heading and default to ascending
      setCurrentHeading(sortHeading);
      setSorted(false);
    }
  };

  return {
    isSorted,
    sortByHeading,
    heading,
    setCurrentHeading,
    sortArray,
  };
};
